import createLucideIcon from '../createLucideIcon';

const ChevronFirst = createLucideIcon('ChevronFirst', [
  ['polyline', { points: '17 18 11 12 17 6', key: '11nco2' }],
  ['path', { d: 'M7 6v12', key: '1p53r6' }],
]);

export default ChevronFirst;
